/* 模板管理 */
const layoutComponent = () => import('@/views/layout')

export default [
  {
    path: '/templateManagement',
    component: layoutComponent,
    meta: {
      title: 'menu.templateManagement',
      icon: 'el-icon-ali-TemplateManagement'
    },
    children: [
      {
        path: '/templateManagement/index',
        name: 'templateManagement',
        component: () => import('@/views/templateManagement/index.vue'),
        meta: {
          title: 'menu.templateLibrary',
          buttons: [
            // { code: 'scan', name: '浏览' },
            // { code: 'addNode', name: '增加节点' },
            // { code: 'addChildNode', name: '增加子节点' },
            // { code: 'deleteNode', name: '删除节点' },
            // { code: 'deleteFile', name: '删除文件' },
            // { code: 'upload', name: '上传' },
            // { code: 'download', name: '下载' }
            { code: 'scan', name: '浏览' },
            {code:'createFolder',name:'创建文件夹'},
            {code:'editFolder',name:'编辑文件夹'},
            {code:'deleteFolder',name:'删除文件夹'},
            {code:'upload',name:'上传'},
            {code:'copyLink',name:'复制链接'},
            {code:'download',name:'下载'},
            {code:'deleteFile',name:'删除文件'},
          ]
        }
      }
    ]
  }
]
